/*
 * View for the topic label and touchpoint label list
 */

define([
  "marionette",
  "jquery",
  "modules/shared/topicLabelList/template/topicLabelListTemplate.html",
  "modules/shared/touchPointLabelList/template/touchPointLabelsTemplate.html",
  "modules/shared/touchPointLabelList/template/touchPointLabelItemTemplate.html",
], function (
  Marionette,
  $,
  TopicLabelListTemplate,
  TouchPointLabelsTemplate,
  TouchPointLabelItemTemplate,
) {
  const TouchPointLabelListView = {};

  TouchPointLabelListView.touchPointLabelView = Marionette.ItemView.extend({
    template: TouchPointLabelItemTemplate,
    tagName: "tr",
    events: {},
    triggers: {
      "change .touchpoint-label": "change:touchpoint:label",
    },
    className: "max-height",
    regions: {
      labelList: "#labelList",
    },

    initialize: function () {
      this.model.on("change", this.render, this);

      const languageId = this.model.get("languageId");
      const defaultTouchpointLabel = this.model.collection.topicFlattenedLabels[languageId];
      this.textboxes = {
        "span.touchpoint-label": {
          enableSelector: "span.touchpoint-label",
          modelAttribute: "summary",
          placeholder: defaultTouchpointLabel,
          textArea: false,
          doNotModifyPlaceholder: true,
        },
      };
    },
    onRender: function () {
      this._applyTextboxes();
    },
    modelChanged: function () {},
  });

  TouchPointLabelListView.touchPointLabelsView = Marionette.CompositeView.extend({
    itemView: TouchPointLabelListView.touchPointLabelView,
    itemViewContainer: "tbody",
    template: TouchPointLabelsTemplate,
    triggers: {},
    initialize: function (options) {
      const flattenedLabels = {};
      options.topicLabels.each(function (label) {
        flattenedLabels[label.get("languageId")] = label.get("summary");
      }, this);

      this.collection.topicFlattenedLabels = flattenedLabels;
    },
  });
  return TouchPointLabelListView;
});
